export const dashboard = {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    meta: {
        title: '数据看板'
    }
};

export const approval = {
    path: '/approval',
    name: 'Approval',
    component: () => import(/* webpackChunkName: "approval" */ '../views/approval/ApprovalList.vue'),
    meta: {
        title: '审批列表'
    }
};

export const approvalDetail = {
    path: '/approval/detail/:id',
    name: 'ApprovalDetail',
    component: () => import(/* webpackChunkName: "approval-detail" */ '../views/approval/ApprovalDetail.vue'),
    meta: {
        title: '审批详情'
    }
};
export const role = {
    path: '/role',
    name: 'Role',
    component: () => import(/* webpackChunkName: "role" */ '../views/Role.vue'),
    meta: {
        title: '角色管理'
    }
};

export const admin = {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue'),
    meta: {
        title: '权限管理'
    }
};

export const banner = { entity: 'notice' };
export const serviceCase = { entity: 'case' };
export const article = { entity: 'article' };
export const venue = { entity: 'venue' };
export const hotel = { entity: 'hotel' };
export const gift = { entity: 'gift' };

export const homeRoute = {
    path: '/',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    name: 'Home',
    children: []
}

export const entityRoute = {
    path: 'entity',
    name: 'Entity',
    component: () => import(/* webpackChunkName: "l" */ '../views/Entity.vue'),
    meta: {},
    children: [
        {
            path: ':type',
            name: 'List',
            component: () => import(/* webpackChunkName: "l" */ '../views/EntityList.vue'),
            meta: {
                keepAlive: true
            },
        },
        {
            path: ':type/add',
            name: 'AddEntity',
            component: () => import(/* webpackChunkName: "a" */ '../views/EntityDetail.vue'),
            meta: {
                keepAlive: false,
                nv: true
            },
        },
        {
            path: ':type/detail/:id',
            name: 'EntityDetail',
            component: () => import(/* webpackChunkName: "d" */ '../views/EntityDetail.vue'),
            meta: {
                keepAlive: false,
                nv: true
            },
        }
    ]
}
